module.exports = __webpack_public_path__ + "static/Products-eed249962a29155192a6e09a13a7811f.png";